module.exports = __webpack_public_path__ + "static/media/crown.c1b06d34.svg";